<!-- close button -->
@if (options.closeButton) {
    <button (click)="remove()" type="button" class="toast-close-button" aria-label="Close">
        <span aria-hidden="true" class="icon icon-clear-2"></span>
    </button>
}

<!-- icon toast -->
@if (showSpinner) {
    <spinner-dialenga class="margin-right-8"></spinner-dialenga>
} @else if (iconNameClass) {
    <span [class]="iconNameClass"></span>
}

<!-- Title and message toast -->
<div class="flex direction-column">
    <!-- title -->
    @if (title) {
        <div [class]="options.titleClass" [attr.aria-label]="title">
            {{ title }}
            @if (duplicatesCount) {
                [{{ duplicatesCount + 1 }}]
            }
        </div>
    }

    <!-- message -->
    @if (message && options.enableHtml) {
        <div role="alert" [class]="options.messageClass" [innerHTML]="message"></div>
    } @else if (message) {
        <div role="alert" [class]="options.messageClass" [attr.aria-label]="message">{{ message }}</div>
    }
</div>

<!-- progressBar -->
@if (options.progressBar) {
    <div>
        <div class="toast-progress" [style.width]="width + '%'"></div>
    </div>
}
